import wixLocation from 'wix-location';
import wixSite from 'wix-site';
import {session} from 'wix-storage';


$w.onReady(function () {
	// Faire apparaître le bouton retour lorsque le menu est affiché
	if (wixSite.currentPage.name === "Menu")
		$w('#btnMenu').label = "FERMER ×";
	else
		$w('#btnMenu').label = "MENU ☰";
});

// --------------------------------- FONCTIONS ---------------------------------
// Appelée lorsque l'on appuie sur le bouton « Menu »
export function btnMenu_click(event) {
	if (wixSite.currentPage.name === "Menu") {
		// Retourner à la page précédente en utilisant l'URL gardé en mémoire
		let pageRetour = session.getItem("pageRetourMenu");

		if (pageRetour !== undefined)
			wixLocation.to(pageRetour);
		else
			wixLocation.to("/accueil");
	}
	else {
		// Garder la page courante en mémoire et rediriger vers le menu
		session.setItem("pageRetourMenu", decodeURI(wixLocation.url.replace(wixLocation.baseUrl, "")));
		wixLocation.to("/menu");
	}
} 

// Appelée lorsque l'on appuie sur une touche dans la barre de recherche
export function txtRecherche_keyPress(event) {
	// Si la touche appuyée est la touche « Enter »
	if (event.key === "Enter") {
		 // Rediriger vers la page « Recherche » avec les bons mots clés
		wixLocation.to("/recherche/q-" + encodeURI($w('#txtRecherche').value) + "/qc-pages");
		// Vider la barre de recherche
		$w('#txtRecherche').value = ""; 
	}
}
